import * as _ from 'lodash';
import { ColumnHandler } from '../types';
import { parseJson, parseDatetime, parseString } from '../converters';
import { PhoneColumnType } from '../../monday-api/api';

export type PhoneColumnValue = {
  text: string | null;
  phone: string | null;
  country_short_name: string | null;
  changed_at: string | null;
};

const handler: ColumnHandler<PhoneColumnType, PhoneColumnValue> = {
  type: 'phone',

  default_value_field: 'text',

  supported_rules: [
    {
      operator: 'any_of',
      compare_value_ids: ['country_short'],
    },
    {
      operator: 'not_any_of',
      compare_value_ids: ['country_short'],
    },
    {
      operator: 'is_empty',
      compare_value_ids: ['empty_null'],
    },
    {
      operator: 'is_not_empty',
      compare_value_ids: ['empty_null'],
    },
    {
      operator: 'contains_text',
      compare_value_ids: ['text'],
    },
    {
      operator: 'not_contains_text',
      compare_value_ids: ['text'],
    },
  ],

  convertValueFromMondayToEngine: (columnValue) => {
    const text = parseString(columnValue.text);
    const value = parseJson(columnValue.value);
    const phone = parseString(_.get(value, 'phone'));
    const countryShortName = parseString(_.get(value, 'countryShortName'));
    const changedAt = parseDatetime(_.get(value, 'changed_at'));

    return {
      text,
      phone,
      country_short_name: countryShortName,
      changed_at: changedAt,
    };
  },

  getFormulaValue: (engineValue) => (engineValue.text === null ? '' : engineValue.text),
};

export default handler;
